import { render, staticRenderFns } from "./OrganizationJsonLD.vue?vue&type=template&id=f699db44&"
import script from "./OrganizationJsonLD.vue?vue&type=script&lang=ts&"
export * from "./OrganizationJsonLD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports